<div class="not-found-wrap text-center">
  <h1 class="text-60"> 500 </h1>
  <p class="text-36 subheading mb-3">Error!</p>
  <p class="mb-5  text-muted text-18">Desculpe! Ocorreu um erro interno. Tente novamente mais tarde</p>
  <button class="btn btn-lg btn-primary btn-rounded" routerLink="/">Voltar para a Home</button>
</div>
